import { jsx as _jsx } from "react/jsx-runtime";
import { Field as FormikField } from "formik";
import { useAlternativeFormik } from "../hooks";
import { useCalculationField } from "@ploy-lib/calculation";
/**
 *
 * @param param0 Make formik patch up internal field with value from variables
 * @returns
 */
function AlternativeFormikField({ altComponent: Component, field: formikField, form: formikForm, ...rest }) {
    const [namespace, fieldname] = formikField.name.split(".");
    const calculation = useCalculationField(namespace, fieldname);
    const { form, field } = useAlternativeFormik(formikField, formikForm, calculation.value);
    if (!Component) {
        return null;
    }
    return _jsx(Component, { ...rest, form: form, field: field });
}
/**
 * Use me instead FormikField when handling fields that are _not_ sumitted, but should be available from CalcRules
 * @param param0
 * @returns
 */
export function CalcRuleFormikField({ component, ...rest }) {
    return (_jsx(FormikField, { component: AlternativeFormikField, ...rest, altComponent: component }));
}
//# sourceMappingURL=CalcRuleFormikField.js.map